import HttpWrapper from '@/utils/http/httpWrapper'
import toastr from 'toastr'
import ShipbobAppSettings from '../../appSettings/appSetting'

export const SHIPBOBPUBLICLOCATIONSAPI_BASEURL = ShipbobAppSettings.ShipBobPublicLocationsApiBaseUrl
export const MERCHANT_PRICING_API = ShipbobAppSettings.MerchantPricingApi.ApiBaseUrl

class FulfillmentCentersServiceInternal {
  urls () {
    return {
      getFulfillmentCenters: SHIPBOBPUBLICLOCATIONSAPI_BASEURL + '/1.0/location/GetAllAvailableLocationsForUser?includeInactive=true',
      getReceivingFulfillmentCenters: SHIPBOBPUBLICLOCATIONSAPI_BASEURL + '/1.0/location/GetAllReceivingLocationsForUser',
      getFulFillmentCenterRulesApi: SHIPBOBPUBLICLOCATIONSAPI_BASEURL + '/1.0/fcconfig/GetUserFulfillmentCenterConfig',
      getCountriesByRegion: SHIPBOBPUBLICLOCATIONSAPI_BASEURL + '/1.0/fcconfig/GetCountriesByGlobalRegion',
      getLocationsShippableToCountries: SHIPBOBPUBLICLOCATIONSAPI_BASEURL + '/1.0/fcconfig/GetLocationsShippableToCountries',
      getGlobalRegions: SHIPBOBPUBLICLOCATIONSAPI_BASEURL + '/1.0/fcconfig/GetGlobalRegions',
      postAddFulfillmentRule: SHIPBOBPUBLICLOCATIONSAPI_BASEURL + '/1.0/fcconfig/SaverUserFcConfigRule',
      postEnableFulfillmentCenterConfig: SHIPBOBPUBLICLOCATIONSAPI_BASEURL + '/1.0/fcconfig/EnableFulfillmentCenterConfig',
      postDisableFulfillmentCenterConfig: SHIPBOBPUBLICLOCATIONSAPI_BASEURL + '/1.0/fcconfig/DisableFulfillmentCenterConfig',
      postDeleteFulfillmentCenterConfig: SHIPBOBPUBLICLOCATIONSAPI_BASEURL + '/1.0/fcconfig/DeleteFulfillmentCenterConfig',
      getUserFulfillmentCentersUrl: SHIPBOBPUBLICLOCATIONSAPI_BASEURL + '/api/FulfillmentCenter/',
      getFulfillmentCentersWithType: SHIPBOBPUBLICLOCATIONSAPI_BASEURL + '/api/FulfillmentCenter/all'
    }
  }

  handleErrorForGettingUserFCs () {
    toastr.error('Unable to retrieve merchant fulfillment centers.')
  }

  async get () {
    const request = {
      Url: `${this.urls().getFulfillmentCenters}`
    }
    const result = await HttpWrapper.Get(request)
    return result
  }

  async getReceiving (includeSpokeFCs = false) {
    const request = {
      Url: `${this.urls().getReceivingFulfillmentCenters}${includeSpokeFCs ? '?IncludeSpokeFcs=true' : ''}`
    }
    const result = await HttpWrapper.Get(request)
    return result
  }

  async getFulfillmentCenterRules (payload) {
    const request = {
      Url: `${this.urls().getFulFillmentCenterRulesApi}`,
      Data: payload
    }
    const result = await HttpWrapper.Post(request)
    return result
  }

  async getCountriesByRegion (payload) {
    const request = {
      Url: `${this.urls().getCountriesByRegion}`,
      Data: payload
    }

    return await HttpWrapper.Post(request)
  }

  async getLocationsShippableToCountries (payload) {
    const request = {
      Url: `${this.urls().getLocationsShippableToCountries}`,
      Data: payload
    }
    const result = await HttpWrapper.Post(request)
    return result
  }

  async getGlobalRegions () {
    const request = {
      Url: `${this.urls().getGlobalRegions}`
    }
    const result = await HttpWrapper.Get(request)
    return result
  }

  async postAddFulfillmentRule (payload) {
    const request = {
      Url: `${this.urls().postAddFulfillmentRule}`,
      Data: payload
    }

    const result = await HttpWrapper.Post(request)
    return result
  }

  async postEnableFulfillmentCenterConfig (payload) {
    const request = {
      Url: `${this.urls().postEnableFulfillmentCenterConfig}`,
      Data: payload
    }

    const result = await HttpWrapper.Post(request)
    return result
  }

  async postDisableFulfillmentCenterConfig (payload) {
    const request = {
      Url: `${this.urls().postDisableFulfillmentCenterConfig}`,
      Data: payload
    }

    const result = await HttpWrapper.Post(request)
    return result
  }

  async postDeleteFulfillmentCenterConfig (payload) {
    const request = {
      Url: `${this.urls().postDeleteFulfillmentCenterConfig}`,
      Data: payload
    }

    const result = await HttpWrapper.Post(request)
    return result
  }

  async getUserFulfillmentCenters () {
    const request = {
      Url: `${this.urls().getUserFulfillmentCentersUrl}`
    }
    return await HttpWrapper.Get(request, undefined, this.handleErrorForGettingUserFCs, true)
  }

  async getFulfillmentCentersWithType () {
    const request = {
      Url: `${this.urls().getFulfillmentCentersWithType}`
    }
    return await HttpWrapper.Get(request, undefined, this.handleErrorForGettingUserFCs, true)
  }
}

export const FulfillmentCentersService = new FulfillmentCentersServiceInternal()
